export const TEMPORAL_TRANSACTION_STATUSES = {
  ACTIVE: 1,
  DELAYED: 2,
  CANCELED: 3,
  RET: 4,
  SO: 5,
  KIT: 6,
};

export const TEMPORAL_TRANSACTION_STATUSES_TEXT:any = {
  1: 'Active',
  2: 'Delayed',
  3: 'Canceled',
  4: 'Retencion',
  5: 'Modificación',
  6: 'Envio de Kit'
};
export class TemporalTransaction {
  id?: number;
  country_id?: number;
  sponsor_id?: number;
  product_id?: number;
  sales_channel_id?: number;


  type_management?: number;
  subtype_management: number;
  subtype2_management: number;

  user_id?: number;
  username?: string;
  guid?:string;
  payload?:string;
  status?: string;
  creation_date?:string;
  customer_name?:string;
  customer_id?:string;
  customer_phone?:string;
  assistance_code?:string;
  transaction_number?:string;
  priority?:number;
  close_date?:string;

  country_name?: string;
  sponsor_name?:string;
  product_name?:string;
  sales_channel_name?:string;

  type_management_name?:string;
  subtype_management_name?:string;
  subtype2_management_name?:string;
  comment?:string;
}
